import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
/** Service Injectable */
var SharedService = /** @class */ (function () {
    /**
     * Method to initialize Service
     */
    function SharedService() {
        /** To store comments */
        this.otpVerified = new Subject();
        /** to share otpVerified which can be subscribed, */
        this.otpVerified$ = this.otpVerified.asObservable();
        /** To store comments */
        this.sharedScreen = new Subject();
        /** to share sharedScreen which can be subscribed, */
        this.sharedScreen$ = this.sharedScreen.asObservable();
        /** token succes */
        this.tokenSuccess = new Subject();
        /** token Failure */
        this.tokenFailure = new Subject();
        this.loadingMessage = "";
    }
    /**
     * paasing otp status
     * @param status passing  otp status
     */
    SharedService.prototype.setOtpStatus = function (status) {
        this.otpVerified.next(status);
    };
    /**
     * fetching step data
     * @param status passing status
     */
    SharedService.prototype.setStepData = function (status) {
        this.sharedScreen.next(status);
    };
    /**
     * getting value if type income
     * @param type passing type value
     * @param value passing skipincome value
     */
    SharedService.prototype.setIsSkipped = function (type, value) {
        if (type == 'income') {
            this.isSkippedIncome = value;
        }
    };
    /**
     * fetching boolean value
     * @param type passing type value
     * @returns boolean value of skip .
     */
    SharedService.prototype.getIsSkipped = function (type) {
        if (type == 'income') {
            return this.isSkippedIncome;
        }
        return false;
    };
    /**
     * This method provides an observable which can be subscribed to in order to listen for token success events.
     * @returns {Observable<any>} An observable that emits token success events.
     */
    SharedService.prototype.getTokenSuccess = function () {
        return this.tokenSuccess.asObservable();
    };
    /**
     * Returns an observable that emits token failure events.
     * This method provides an observable which can be subscribed to in order to listen for token failure events.
     * @returns {Observable<any>} An observable that emits token failure events.
     */
    SharedService.prototype.getTokenFailure = function () {
        return this.tokenFailure.asObservable();
    };
    SharedService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SharedService_Factory() { return new SharedService(); }, token: SharedService, providedIn: "root" });
    return SharedService;
}());
export { SharedService };
